export const createGroupMapKFSData = (data) => {
    // Your data object with nested properties
    // const data = {
    //     item1: { parentId: 'parent1', name: 'Item 1' },
    //     item2: { parentId: 'parent1', name: 'Item 2' },
    //     item3: { parentId: 'parent2', name: 'Item 3' },
    //     item4: { parentId: 'parent3', name: 'Item 4' },
    //     // ... other items
    // };
    // Create a map of objects based on parentId
    const mapByParentId = Object.values(data).reduce((map, obj) => {
        const parentId = obj['parentId'];
        if (parentId) {
            if (parentId && !map[parentId]) {
                map[parentId] = [];
            }
            map[parentId].push(obj);
        }
        return map;
    }, {});
    // console.log("mapByParentId: ", mapByParentId);
    return mapByParentId;
};
export const hasOnlyDescriptionAndValue = (obj) => {
    // Check if the object has exactly two properties
    // if (Object.keys(obj).length !== 2) {
    //     return false;
    // }
    // Check if the object has properties "description" and "value"
    if (Object.keys(obj).length === 2 &&
        obj.hasOwnProperty('description') &&
        obj.hasOwnProperty('value')) {
        return true;
    }
    return false;
};
export const hasPropertySubText = (obj) => {
    if (obj.hasOwnProperty('subText')) {
        return true;
    }
    return false;
};
